/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'ptc.pm.collaborators.title': 'Your Collaborators',
  'ptc.pm.error-heading': 'Something’s gone wrong',
  'ptc.pm.error-image-alt-text': 'A broken robot and a number of people busy fixing it.',
  'ptc.pm.error-text': 'We keep track of these errors, but feel free to contact us if refreshing doesn’t fix things',
  'ptc.pm.num-members': '{memberCount, plural, one {# member} other {# members} }',
  'ptc.pm.people': 'People',
  'ptc.pm.teams': 'Teams',
  'ptc.pm.view-your-profile': 'View your profile',
  'ptc.pm.your-teams.title': 'Your Teams',
};
